namespace uh.sound {
    export class SoundManager {

        private static _instance:SoundManager = null;
        public static getInstance():SoundManager {
            if (!SoundManager._instance) {
                SoundManager._instance = new SoundManager(game.scene.getAt(0));
            }
            return SoundManager._instance;
        }

        private music = null;
        private sounds: Array<Phaser.Sound.BaseSound> = [];

        private currentMusic: string = "";

        private scene: Phaser.Scene;

        constructor(scene: Phaser.Scene) {
            this.scene = scene;
        }

        public playMusic(filename: string, loop: boolean = false, volume:number = 1): Phaser.Sound.BaseSound {
            if (this.currentMusic == filename) {
                return;
            }
            this.stopMusic();
            this.music = this.scene.sound.add(filename);
            this.music["filename"] = filename;
            this.music.loop = loop;
            this.music.play();
            this.music.setVolume(volume);
            this.currentMusic = filename;

            return this.music;
        }

        public stopMusic(): any {
            this.currentMusic = "";
            if (this.music) this.music.stop();
        }

        public setVolume(volume:number): void {
            game.sound.volume = volume;
        }

        public playSound(filename: string, volume:number = 1, loop: boolean = false): Phaser.Sound.BaseSound {
            let snd:string = filename;
            try {
                let s: any = this.scene.sound.add(snd);
                s["filename"] = filename;
                s.loop = loop;
                s.play();
                s.setVolume(volume);
                this.sounds.push(s);
                return s;
            } catch {
            }
            return  null;
        }

        public stopSound(): void {
            for (let s of this.sounds) s.stop();
        }
    }
}
